import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import ControlledModal from '../../../components/modals/ControlledModal'
import Details from './Details'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import UserLoader from './_load/UserLoader'

const ShowUserModal = props => {
  return (
    <ControlledModal width="48rem" {...props}>
      <UserLoader>
        <ModalHeader />

        <LineSeparator color="light2" weight={4} />

        <Grid justify="space-between" align="flex-start" paddingGutter={0.5}>
          <Col flex={2}>
            <Separator weight={6} />
            <Details />
          </Col>
        </Grid>
      </UserLoader>
    </ControlledModal>
  )
}

export default ShowUserModal
